module.exports = __webpack_public_path__ + "static/partner-img1-a2bb08a71d690d9e3e46ae0478029280.png";